module.exports = __webpack_public_path__ + "media/images/mv1_bg-2434424783ccc5239b216621ff11952d.png";